 <template>
    <div>
 <!-- Alternate Logins -->
        <div class="pt3 ph3">
            <a href="/api/auth/login/facebook" class="no-underline"><FacebookButton class="mb2">Log in with Facebook</FacebookButton></a>
            <a href="/api/auth/login/google" class="no-underline"><GoogleButton>Log in with Google</GoogleButton></a>
        </div>

        <!-- or -->
        <LabeledLine class="mv3"><h6 class="mid-gray">or</h6></LabeledLine>

        <!-- Regular Login -->
        <div class="ph3">
            <Textbox class="mb2" v-model="credentials.email" type="email" name="email" placeholder="Email Address"/>
            <Textbox class="mb2" v-model="credentials.password" type="password" name="password" placeholder="Password"/>
            <TooliabaButton @click="loginClick">Log In</TooliabaButton>
        </div>

        <div class="tc mt3">
            <a class="link mid-gray pointer" @click="$emit('forgotClick')"><h6 class="grow">Forgot Your Password?</h6></a>
        </div>
    </div>
</template>

<script>
import FacebookButton from '@/components/buttons/FacebookButton.vue';
import GoogleButton from '@/components/buttons/GoogleButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import LabeledLine from '@/components/controls/LabeledLine.vue';
import Textbox from '@/components/controls/Textbox.vue';
import { mapMutations } from 'vuex';

export default {
    components: {
        FacebookButton,
        GoogleButton,
        TooliabaButton,
        LabeledLine,
        Textbox
    },
    data: function() {
        return {
            credentials: {
                email: '',
                password: ''
            }
        };
    },
    methods: {
        ...mapMutations('users', ['updateCurrentUser']),
        loginClick() {
            var redirect = this.$auth.redirect();

            this.$auth.login({
                data: this.credentials,
                rememberMe: true,
                fetchUser: false,
                success: response => this.updateCurrentUser(response.data.user),
                redirect: { path: redirect ? redirect.from.path : '/' }
            });
        }
    }
};
</script>
